import { useDispatch, useSelector } from 'react-redux';
import { useCallback } from 'react';
import { dashboardActions } from '../../../../../../store/slices/dashboardSlice/dashboardSlice';

export const useTeamMembersList = () => {
    const { information, can_show_financial_info } = useSelector(
        //@ts-ignore
        (state) => state.dashboardReducer
    );
    const dispatch = useDispatch();
    const showProjectTeam = useCallback(() => {
        dispatch(dashboardActions.onModalMode('teamProject'));
    }, []);
    return {
        showProjectTeam,
        sortedUsers: {
            users: information.projectUsers.sorted_users.users,
            rest_of_team_count: information.projectUsers.sorted_users.rest_of_team_count,
        },
        can_show_financial_info,
    };
};
